import styled from 'styled-components/native';
import style, { hpx } from '../../styles';

export const Container = styled.View`
  background: ${props => props.theme.colors.primary};
  align-items: center;
  padding: ${hpx(40)} ${hpx(20)} ${hpx(20)};
`;

export const SectionContainer = styled.View`
  width: 100%;
  max-width: 500px;
  align-items: center;
  margin-bottom: ${hpx(30)};
  border-bottom-width: 1px;
  border-bottom-color: rgba(255, 255, 255, 0.1);
  padding-bottom: ${hpx(20)};
`;

export const Title = styled.Text`
  color: ${props => props.theme.colors.secondary};
  font-size: ${style.fonts.large};
  font-family: ${style.fontName.ubuntuBold};
  margin-bottom: ${hpx(15)};
  text-align: center;
`;

export const Subtitle = styled.Text`
  color: ${props => props.theme.colors.secondary};
  font-size: ${style.fonts.medium};
  margin-bottom: ${hpx(10)};
  font-family: ${style.fontName.ubuntuBold};
  text-align: center;
  opacity: 0.9;
`;

export const Text = styled.Text`
  color: ${props => props.theme.colors.secondary};
  font-size: ${style.fonts.small};
  margin-bottom: ${hpx(8)};
  font-family: ${style.fontName.ubuntuRegular};
  text-align: center;
  line-height: ${hpx(22)};
  opacity: 0.8;
`;

export const SmallSubtitle = styled.Text`
  color: ${props => props.theme.colors.secondary};
  font-size: ${style.fonts.xsmall};
  margin-bottom: ${hpx(5)};
  font-family: ${style.fontName.ubuntuBold};
  text-align: center;
`;

export const ContainerSocialNetworks = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: ${hpx(10)};
  margin-bottom: ${hpx(20)};
`;

export const SponsorContainer = styled.TouchableOpacity`
  align-items: center;
  padding: ${hpx(20)};
  margin-top: ${hpx(30)};
  opacity: 0.7;
`;

export const CopyrightText = styled.Text`
  color: ${props => props.theme.colors.secondary};
  font-size: ${style.fonts.xxsmall};
  font-family: ${style.fontName.ubuntuRegular};
  text-align: center;
  opacity: 0.6;
  margin-top: ${hpx(10)};
`;

export const FooterContainer = styled.View`
  position: relative;
  width: 100%;
`;
